import { render, staticRenderFns } from "./binding-iphone.vue?vue&type=template&id=2bf7d76a&scoped=true&"
import script from "./binding-iphone.vue?vue&type=script&lang=js&"
export * from "./binding-iphone.vue?vue&type=script&lang=js&"
import style0 from "./binding-iphone.vue?vue&type=style&index=0&id=2bf7d76a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf7d76a",
  null
  
)

export default component.exports